import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Success.css';

const Success = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="success-page">
      <div className="success-card card">
        <div className="success-icon">✓</div>
        <h1>Order Complete!</h1>
        <p className="success-message">
          Thank you for your purchase! Your order has been successfully placed.
        </p>
        <p className="success-details">
          You will receive an email confirmation shortly with your order details
          and tracking information.
        </p>
        {sessionId && (
          <p className="session-id">
            Order Reference: <code>{sessionId.slice(-8)}</code>
          </p>
        )}
        <div className="success-actions">
          <Link to="/" className="btn btn-primary">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
